import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {MdCloudUpload} from "react-icons/md";

import css from "./ModalForImportXLS.module.css";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";


const ModalForImportXLS = ({onClose, titleName}) => {
    const {register, handleSubmit, setValue} = useForm();
    const [selectedFile, setSelectedFile] = useState(null);
    const {t} = useTranslation();
    const {pathname} = useLocation();


    console.log('pathname', pathname);

    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            setSelectedFile(file);
            setValue("file", file);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const file = event.dataTransfer.files[0];
            setSelectedFile(file);
            setValue("file", file);
        }
    };

    const onSubmit = (data) => {
        console.log("Uploading file:", data.file);
        // Implement file upload logic here (e.g., API call)
    };

    return (
        <div className={css.overlay}>
            <div className={css.modal}>
                <h2>{titleName}</h2>

                <a href="/path-to-template.xls" className={css.downloadButton} download>
                    Скачать xls шаблон
                </a>

                <form onSubmit={handleSubmit(onSubmit)} className={css.form}>
                    <div
                        className={css.dropzone}
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                    >
                        <input
                            type="file"
                            id="fileUpload"
                            {...register("file")}
                            className={css.fileInput}
                            onChange={handleFileChange}
                            accept=".xls,.xlsx"
                        />
                        <label htmlFor="fileUpload" className={css.uploadArea}>
                            <MdCloudUpload className={css.uploadIcon}/>
                            {selectedFile ? (
                                <span>{selectedFile.name}</span>
                            ) : (
                                <span>
                                    {t("Drop-file-here-or")}
                                    <span className={css.selectText}>{t("click-to-upload")}</span>
                </span>
                            )}
                        </label>
                    </div>

                    <button type="submit" className={css.uploadButton}>
                        Загрузить
                    </button>
                </form>

                <button className={css.closeButton} onClick={onClose}>
                    ×
                </button>
            </div>
        </div>
    );
};

export {ModalForImportXLS};
